module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/film-0925c71c3eb5d95a8c0a5bbad6b051d6.svg";